export const SAVE = 'changesToYourJourneySCTIStep.SAVE';
export const VALUE_CHANGED = 'changesToYourJourneySCTIStep.VALUE_CHANGED';
export const LOAD = 'changesToYourJourneySCTIStep.VALUE_LOAD';
export const NEXT = 'changesToYourJourneySCTIStep.NEXT';
export const RESET = 'changesToYourJourneySCTIStep.RESET';
export const RESET_DAMAGED_LOST_EXPENSE = 'changesToYourJourneySCTIStep.RESET_DAMAGED_LOST_EXPENSE';
export const RESET_DELAYED_LUGGAGE_EXPENSE = 'changesToYourJourneySCTIStep.RESET_DELAYED_LUGGAGE_EXPENSE';
export const RESET_COMPENSATION = 'changesToYourJourneySCTIStep.RESET_COMPENSATION';
//------------------------------------------------------
export const RESET_FOR_DAMAGE_LOST_OR_STOLEN_LUGGAGE_STATE = 'changesToYourJourneySCTIStep.RESET_FOR_DAMAGE_LOST_OR_STOLEN_LUGGAGE_STATE';
export const RESET_FOR_BAGGAGE_DELAY_STATE = 'changesToYourJourneySCTIStep.RESET_TRAVEL_INTERRUPTION_STATE';
export const RESET_EUROPEAN_UNION_STATE = 'changesToYourJourneySCTIStep.RESET_EUROPEAN_UNION_STATE';
//--------------------------------------------------------
export const RESET_BEFORE_LEAVING_STATE = 'changesToYourJourneySCTIStep.RESET_BEFORE_LEAVING_STATE';
export const RESET_SPECIAL_EVENT_STATE = 'changesToYourJourneySCTIStep.RESET_SPECIAL_EVENT_STATE';
export const RESET_PELEVANT_PERSON_STATE = 'changesToYourJourneySCTIStep.RESET_PELEVANT_PERSON_STATE';
export const RESET_TRAVEL_AGENT_STATE = 'changesToYourJourneySCTIStep.RESET_TRAVEL_AGENT_STATE';
export const RESET_AFTER_LEAVING_STATE = 'changesToYourJourneySCTIStep.RESET_AFTER_LEAVING_STATE';
export const RESET_SPECIAL_EVENT_AL_STATE = 'changesToYourJourneySCTIStep.RESET_SPECIAL_EVENT_AL_STATE';
export const RESET_PELEVANT_PERSON_AL_STATE = 'changesToYourJourneySCTIStep.RESET_PELEVANT_PERSON_AL_STATE';
export const RESET_PELEVANT_PERSON_EXISTING_HEALTH_AL_STATE = 'changesToYourJourneySCTIStep.RESET_PELEVANT_PERSON_EXISTING_HEALTH_AL_STATE';
export const RESET_CUTTING_YOU_TRIP_STATE = 'changesToYourJourneySCTIStep.RESET_CUTTING_YOU_TRIP_STATE';
export const RESET_TRAVEL_INTERRUPTION_STATE = 'changesToYourJourneySCTIStep.RESET_TRAVEL_INTERRUPTION_STATE';
export const RESET_RESUMING_YOUR_TRIP_BACK_OVERSEAS_STATE = 'changesToYourJourneySCTIStep.RESET_RESUMING_YOUR_TRIP_BACK_OVERSEAS_STATE';
export const RESET_THE_RELEVANT_PERSON_STATE = 'changesToYourJourneySCTIStep.RESET_THE_RELEVANT_PERSON_STATE';
export const RESET_TRAVEL_PLANS_ORGANISED_BY_A_TRAVEL_AGENT = 'changesToYourJourneySCTIStep.RESET_TRAVEL_PLANS_ORGANISED_BY_A_TRAVEL_AGENT';
export const RESET_TRAVEL_AGENT_CANCELLATION_FEE = 'changesToYourJourneySCTIStep.RESET_TRAVEL_AGENT_CANCELLATION_FEE';

export const REPORT_TO = {
  POLICE: '1',
  HOTEL_MANAGEMENT: '2',
  CRUISE_SHIP: '3',
  AIRLINE: '4',
  TOUR_GUIDE: '5',
  OTHER: '6',
  NOT_REPORT: '20',
};

export const CLAIMING_FOR = {
  PASSPORT_CREDIT_CARD: 'claimForPassportCreditCard',
  THEFT_OF_CASH: 'claimForTheftOfCash',
  LUGGAGE_AND_PERSONAL_EFFECTS: 'claimForLuggageAndPersonalEffect',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.ChangesToYourJourney/constants.js